import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, Form } from "react-bootstrap";
import { auth } from '../firebase';

function BottomNav()  {

    const [show, setShow] = useState(false);
    const [openSignIn, setOpenSignIn] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
        if (authUser) {
            console.log(authUser);
            setUser(authUser);

        } else {
            setUser(null);
        }

        return () => {
          unsubscribe();
        }
        
        
    })
  }, [user, username]);


  const signUp = (event) => {
    event.preventDefault();

    auth
    .createUserWithEmailAndPassword(email, password)
    .then((authUser) => {
      authUser.user.updateProfile({
        displayName: username
      })
    })
    .catch((error) => alert(error.message))
    
    handleClose(true);
  }

  const signIn = (event) => {
    event.preventDefault();

    auth.signInWithEmailAndPassword(email, password)
    .catch((error) => alert(error.message))
    
    setOpenSignIn(false);
  }

        return ( 
            <div className="fixed-bottom navbar navbar-light d-flex justify-content-center shadow">
                {user ? (
          <Button variant="bg-none" onClick={() => auth.signOut()}>
          Logout
        </Button>
        
        ): (
          <div>
            <Button variant="dark" className="btn-sm" onClick={handleShow}>
        Sign up
      </Button>
      <Button variant="bg-none" onClick={() => setOpenSignIn(true)}>
        Log in
      </Button>
          </div>
        )}

<Modal show={openSignIn} onHide={setOpenSignIn} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Login</Modal.Title>
        </Modal.Header>

        <ModalBody>
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
              type="email" 
              placeholder="Enter email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control 
              type="password" 
              placeholder="Password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <Button 
            variant="dark" 
            type="submit"
            onClick={signIn}
            >
              Login
            </Button>
          </Form>
        </ModalBody>
      </Modal>
        

      <Modal show={show} onHide={handleClose} keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Sign up</Modal.Title>
        </Modal.Header>

        <ModalBody>
          <Form>
          <Form.Group controlId="formBasicUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
               type="text"  
               placeholder="username"
               value={username}
               onChange={(e) => setUsername(e.target.value)}
               />
            </Form.Group>

            <Form.Group controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control 
              type="email" 
              placeholder="Enter email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              />
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>

            <Form.Group controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control 
              type="password" 
              placeholder="Password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <Button 
            variant="dark" 
            type="submit"
            onClick={signUp}
            >
              Sign up
            </Button>
          </Form>
        </ModalBody>
      </Modal>
            </div>
         );
    }
 
export default BottomNav;